import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container mt-0 mb-3" }
const _hoisted_2 = { class: "row text-center gx-2" }
const _hoisted_3 = { class: "col" }
const _hoisted_4 = {
  key: 0,
  class: "col"
}
const _hoisted_5 = {
  key: 1,
  class: "col"
}
const _hoisted_6 = { class: "col" }
const _hoisted_7 = {
  key: 2,
  class: "col"
}

import { computed, PropType } from "vue";
import HelpText from "@/guiide/ts/helpText";
import DBOptionsStat from "@/guiide/components/dboptions/DBOptionsStat.vue";
import FinalSalaryOption from "@/guiide/ts/assets/finalsalary/finalSalaryOption";
import { useUIContent } from "@/guiide/ts/configuration/useUIContent";


export default /*@__PURE__*/_defineComponent({
  __name: 'DBOptionsStats',
  props: {
    lifeExpectancy: { type: String, required: true },
    breakevenAge: { type: String, required: true },
    crossoverAge: { type: String, required: true },
    averageSchemeIncreases: { type: Number, required: true },
    showPIEStats: { type: Boolean, required: true },
    averagePIEIncreases: { type: Number, required: true },
    selectedOption: { type: Number as PropType<FinalSalaryOption>, required: true },
    userHasMultipleOptions: { type: Boolean, required: true }
},
  setup(__props) {

const props = __props;

const { textArray, htmlArray } = useUIContent();

const averageSchemeIncreasesText = computed<string>(() => `${props.averageSchemeIncreases.toFixed(2)}%`);

const showPIEDetails = computed<boolean>(() => props.selectedOption == FinalSalaryOption.PensionIncreaseExchange);

const averagePIEIncreasesText = computed<string>(() => {
    return showPIEDetails.value
        ? `${props.averagePIEIncreases.toFixed(2)}%`
        : "n/a";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(DBOptionsStat, {
          label: "Life expectancy",
          helpText: _unref(htmlArray)('dboptions.important-info.life-expectancy.read-more.body'),
          value: __props.lifeExpectancy
        }, null, 8, ["helpText", "value"])
      ]),
      (__props.showPIEStats)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(DBOptionsStat, {
              label: "Crossover age",
              helpText: _unref(textArray)('dboptions.modelling.stats.crossover-age.help.body'),
              value: __props.crossoverAge
            }, null, 8, ["helpText", "value"])
          ]))
        : _createCommentVNode("", true),
      (__props.showPIEStats)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(DBOptionsStat, {
              label: "Breakeven age",
              helpText: _unref(textArray)('dboptions.modelling.stats.breakeven-age.help.body'),
              value: __props.breakevenAge
            }, null, 8, ["helpText", "value"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(DBOptionsStat, {
          label: "Average annual increase",
          helpText: _unref(HelpText).DBOptionsStandardPensionOption(),
          value: averageSchemeIncreasesText.value,
          subHeading: "Standard Pension Option",
          showSubHeading: __props.userHasMultipleOptions
        }, null, 8, ["helpText", "value", "showSubHeading"])
      ]),
      (__props.showPIEStats)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(DBOptionsStat, {
              label: "Average annual increase",
              helpText: _unref(HelpText).DBOptionsPIE(),
              value: averagePIEIncreasesText.value,
              subHeading: "Pension Increase Exchange"
            }, null, 8, ["helpText", "value"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})